import * as React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Account from './Account';
import NextofKim from './NextOfKin';
import Security from './Security';
import { Outlet, useLocation } from 'react-router-dom';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function TopSec() {
  const location = useLocation();
  const [value, setValue] = React.useState(0);

  React.useEffect(() => {
    if (location.state?.activeTab !== undefined) {
      setValue(location.state.activeTab);
    }
  }, [location.state]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Outlet />
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value}
          textColor="inherit"
          sx={{
            '& .MuiTabs-indicator': { backgroundColor: '#00BC67' },
            '& .MuiTab-root': { color: '#1E222B' },
            '& .Mui-selected': { color: '#00BC67' },
          }}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label={<p className=' capitalize font-[500] text-[16px]'>Account</p>}
            {...a11yProps(0)} />
          <Tab label={<p className=' capitalize font-[500] text-[16px]'>Next of kin</p>} {...a11yProps(1)} />
          <Tab label={<p className=' capitalize font-[500] text-[16px]'>Security</p>} {...a11yProps(2)} />


        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <Account />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <NextofKim />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <div>
          <Security />
        </div>

      </TabPanel>

    </Box>
  );
}